import { alpha, type Theme, type Components } from "@mui/material/styles";

export const navigationCustomizations: Components<Theme> = {
  MuiMenuItem: {
    styleOverrides: {
      root: ({ theme }) => ({
        minHeight: 44,
        padding: "10px 12px",
        borderRadius: 4,
        "&.Mui-focusVisible": { backgroundColor: theme.palette.action.focus },
        "&.Mui-selected": {
          backgroundColor: theme.palette.action.selected,
          "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, 0.16),
          },
        },
        "@media (min-width: 600px)": { minHeight: 44 },
      }),
    },
  },
  MuiMenu: {
    styleOverrides: {
      list: { padding: 6 },
      paper: ({ theme }) => ({
        marginTop: 4,
        borderRadius: 8,
        border: `1px solid ${theme.palette.divider}`,
        backgroundImage: "none",
        backgroundColor: theme.palette.background.paper,
        boxShadow: `0 8px 28px ${alpha(theme.palette.common.black, theme.palette.mode === "dark" ? 0.28 : 0.1)}`,
      }),
    },
  },
  MuiSelect: {
    styleOverrides: {
      select: { display: "flex", alignItems: "center", minWidth: 0 },
    },
  },
  MuiLink: {
    defaultProps: { color: "inherit", underline: "always" },
    styleOverrides: {
      root: {
        textUnderlineOffset: "4px",
        "&:focus-visible": { outline: "2px solid", outlineOffset: 3 },
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        backgroundImage: "none",
      }),
    },
  },
  MuiPaginationItem: {
    styleOverrides: {
      root: ({ theme }) => ({
        minWidth: 40,
        minHeight: 40,
        "&.Mui-selected": {
          color: theme.palette.primary.main,
          backgroundColor: theme.palette.action.selected,
        },
      }),
    },
  },
  MuiTabs: {
    styleOverrides: {
      root: { minHeight: 44 },
      indicator: ({ theme }) => ({
        backgroundColor: theme.palette.primary.main,
      }),
    },
  },
  MuiTab: {
    styleOverrides: {
      root: ({ theme }) => ({
        minHeight: 44,
        minWidth: 0,
        padding: "10px 16px",
        textTransform: "none",
        fontWeight: 500,
        color: theme.palette.text.secondary,
        "&:hover": { backgroundColor: theme.palette.action.hover },
        "&.Mui-selected": { color: theme.palette.primary.main },
      }),
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: ({ theme }) => ({
        fontSize: "0.8125rem",
        lineHeight: 1.5,
        padding: "8px 12px",
        borderRadius: 4,
        color: theme.palette.background.default,
        backgroundColor: theme.palette.text.primary,
      }),
    },
  },
};
